import { useSelector } from "react-redux";
import { getCurrentUser } from "../redux/applicationUserSlice";
import { ApplicationUserRole } from "../api";
import {normalizeApplicationUserRoles} from "../helpers/applicationUserHelper";

export default function useCurrentUserRoles(): ApplicationUserRole[] | null | undefined {
    const roles = useSelector(getCurrentUser)?.roles;
    return roles ? normalizeApplicationUserRoles(roles) : roles;
}
